import React from "react";
import { useLanguage } from "../../context/LanguageContext";
import { journalTranslations } from "../../locales/journalTranslations";

export default function OurJournals() {
  const { currentLanguage } = useLanguage();
  const t = journalTranslations[currentLanguage] || journalTranslations.en;
  const list = t.journals || [];

  return (
    <div style={{ padding: "60px 20px", background: "#f8fafc", minHeight: "80vh" }}>
      <div style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto 40px auto" }}>
        <h1 style={{ fontSize: "2.4rem", fontWeight: "800", color: "#0f172a", marginBottom: "12px" }}>
          {t.pageTitle}
        </h1>
        <p style={{ color: "#64748b", fontSize: "1.05rem", lineHeight: "1.6" }}>
          {t.pageSubtitle}
        </p>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "30px",
          maxWidth: "1300px",
          margin: "0 auto",
        }}
      >
        {list.map((journal) => (
          <div
            key={journal.id}
            style={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              boxShadow: "0 4px 16px rgba(15, 23, 42, 0.06)",
              border: "1px solid #e2e8f0",
              padding: "24px",
              display: "flex",
              flexDirection: "column",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-6px)";
              e.currentTarget.style.boxShadow = "0 16px 32px rgba(15, 23, 42, 0.12)";
              e.currentTarget.style.borderColor = "#93c5fd";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 16px rgba(15, 23, 42, 0.06)";
              e.currentTarget.style.borderColor = "#e2e8f0";
            }}
          >
            <img
              src={journal.image}
              alt={journal.title}
              style={{
                width: "100%",
                height: "250px",
                objectFit: "contain",
                backgroundColor: "#f1f5f9",
                borderRadius: "12px",
                marginBottom: "18px",
                padding: "8px",
              }}
            />
            <h2
              style={{
                fontSize: "1.1rem",
                fontWeight: "700",
                marginBottom: "12px",
                color: "#0f172a",
                lineHeight: "1.4",
              }}
            >
              {journal.title}
            </h2>

            <p
              style={{
                fontSize: "0.9rem",
                color: "#64748b",
                marginBottom: "22px",
                flexGrow: 1,
                lineHeight: "1.65",
              }}
            >
              {journal.description}
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "auto" }}>
              <a
                href={journal.viewLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  border: "1.5px solid #4D49BF",
                  color: "#4D49BF",
                  padding: "10px 16px",
                  textAlign: "center",
                  borderRadius: "8px",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(77, 73, 191, 0.08)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                }}
              >
                {t.viewJournal}
              </a>

              <a
                href={journal.submitLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  background: "linear-gradient(135deg, #4D49BF 0%, #05DBF2 100%)",
                  color: "#ffffff",
                  padding: "10px 16px",
                  textAlign: "center",
                  borderRadius: "8px",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  boxShadow: "0 4px 12px rgba(77, 73, 191, 0.35)",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 6px 16px rgba(5, 219, 242, 0.45)";
                  e.currentTarget.style.transform = "translateY(-1px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(77, 73, 191, 0.35)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                {t.submitPaper}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
